<template>
  <v-dialog
    v-model="dialog"
    max-width="900px"
    scrollable
    @input="changeDialog($event)">
    <template v-slot:activator="{ on, attrs }">
      <div class="relative">
        <v-img
          :src="avatar"
          height="160"
          class="receipt-avatar"
          contain>
        </v-img>
        <span class="font-weight-medium">
          {{ $t('receipt.note.size.8cm') }}
        </span>
        <div class="edit-template">
          <v-btn
            color="primary"
            rounded
            depressed
            v-bind="attrs"
            v-on="on">
            <v-icon small>
              mdi-cog
            </v-icon>
            <span> {{ $t('receipt.btn.setting') }} </span>
          </v-btn>
        </div>
      </div>
    </template>
    <card-dialog
      v-model="form.addressSize"
      :title="$t('receipt.note.cmTitle')"
      :avatar="avatar"
      :items="previewType"
      @input="submit('addressSize')">
      <v-card
        class="app-card pt-2 pb-16 h-100 card-form-dialog"
        tile>
        <v-toolbar
          class="mb-3"
          flat
          dense>
          <v-toolbar-title class="text-subtitle-1 secondary--text font-weight-medium">
            {{ $t('receipt.editTitle') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            small
            @click="closeDialog()">
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-container>
          <v-row>
            <v-col
              v-if="form.addressSize === 'long'"
              cols="12">
              <toggle-form
                v-model="form.invoiceShowTag"
                :text="$t('receipt.note.field.tag.label')"
                :state="state['invoiceShowTag']"
                @input="submit('invoiceShowTag')" />
            </v-col>
            <v-col
              v-else
              cols="12">
              <div class="secondary--text">
                {{ $t('receipt.note.empty') }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </card-dialog>
  </v-dialog>
</template>

<script>
import { GET_SETTING_RECEIPT, UPDATE_SETTING } from '@/resources/graphql'
import CardDialog from '@/views/Receipt/components/CardDialog.vue'

export default {
  apollo: {
    setting: () => ({
      fetchPolicy: 'no-cache',
      query: GET_SETTING_RECEIPT,
      result ({ data: { setting } }) {
        this.form.invoiceShowTag = setting.invoiceShowTag
      }
    })
  },
  components: {
    CardDialog
  },
  data () {
    return {
      dialog: false,
      state: {
        invoiceShowTag: 'ready'
      },
      form: {
        invoiceShowTag: null,
        addressSize: 'long'
      },
      box: {
        'false-long': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/box/8cm/isnotTag-LongPaper.jpg`,
        'false-short': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/box/8cm/isnotTag-shortPaper.jpg`,
        'true-long': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/box/8cm/isTag-LongPaper.jpg`,
        'true-short': `${process.env.VUE_APP_ROUTE_PREFIX}imgs/box/8cm/isnotTag-shortPaper.jpg`
      },
      previewType: [{ name: 'กระดาษยาว', value: 'long' }, { name: 'กระดาษสั้น', value: 'short' }]
    }
  },
  computed: {
    avatar () {
      const src = this.box[`${this.form.invoiceShowTag}-${this.form.addressSize}`]
      return src
    }
  },
  methods: {
    changeDialog (dialog) {
      if (dialog) { this.$apollo.queries.setting.refetch() }
    },
    closeDialog () {
      this.dialog = false
    },
    async submit (field) {
      this.state[field] = 'loading'
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            [field]: this.form[field]
          }
        }
      }).catch(() => {
        this.state[field] = 'error'
      })
      if (res) {
        const { data: { updateSetting } } = res
        if (updateSetting.errors && Object.keys(updateSetting.errors).length) {
          this.state[field] = 'error'
        } else {
          this.state[field] = 'success'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
</style>
